export const css = {
    root: '_9VJGCY5-',
    copyright: '_1260F-dX',
    selector: '_4h13t5pU',
    privacypolicy: '_2OJPApj1',
    disclaimer: '_3r9E1UPs',
    alt: '_3uK2age2',
    alt_img: '_2sJN-trp',
    alt_disclaimer: '_2VxmD9gP',
    ' _key': 'lcc-app/footer'
};
export default css;
